module.exports = __webpack_public_path__ + "img/contract.525582fc.png";